import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import {
  Button,
  Checkbox,
  Form,
  Header,
  Modal,
  Radio,
  Segment,
} from "semantic-ui-react";
import { Loading } from "../components/common/loading";
import { EnvelopSize } from "../modules/donation/components";

interface IEnvelopsMultiModal extends WithTranslation {
  trigger: any;
  onConfirm: (
    letterType: string,
    fileType: string,
    envelopSize: string
  ) => void;
}

class EnvelopsMultiModal extends React.Component<IEnvelopsMultiModal> {
  public _isMounted = false;
  public state = {
    open: false,
    loading: false,
    fileType: "pdf",
    envelopSize: "1",
    letterType: "CLB",
  };
  public componentDidMount() {
    this._isMounted = true;
  }
  public componentWillUnmount() {
    this._isMounted = false;
  }
  public close = () => {
    if (this._isMounted) {
      this.setState({ open: false });
    }
  };
  public open = () => {
    if (this._isMounted) {
      this.setState({ open: true });
    }
  };
  public render() {
    const { trigger, t } = this.props;
    const { open } = this.state;
    return (
      <Modal
        trigger={trigger}
        onOpen={this.open}
        size="mini"
        open={open}
        onClose={this.close}
      >
        <Header icon={"print"} content={t("modal.EnvelopsModal.header")} />
        <Modal.Content scrolling>
          <Loading active={this.state!.loading} />
          <Form>
            <Form.Field>
              <label>{"ประเภทของซอง"}</label>
              <Segment>
                <Form.Group>
                  <Form.Field
                    control={Radio}
                    label={"ผู้กู้"}
                    onChange={(
                      event: React.SyntheticEvent<HTMLElement>,
                      data: any
                    ) => this.setState({ letterType: "CLB" })}
                    checked={this.state.letterType === "CLB"}
                  />
                  <Form.Field
                    control={Radio}
                    label={"ผู้ค้ำ"}
                    onChange={(
                      event: React.SyntheticEvent<HTMLElement>,
                      data: any
                    ) => this.setState({ letterType: "CLG" })}
                    checked={this.state.letterType === "CLG"}
                  />
                </Form.Group>
              </Segment>
            </Form.Field>
            <Form.Field>
              <label>{t("modal.EnvelopsModal.headerFileType")}</label>
              <Segment>
                <Form.Group>
                  <Form.Field
                    control={Radio}
                    label={"PDF"}
                    onChange={(
                      event: React.SyntheticEvent<HTMLElement>,
                      data: any
                    ) => this.setState({ fileType: "pdf" })}
                    checked={this.state.fileType === "pdf"}
                  />
                  <Form.Field
                    control={Radio}
                    label={"MS Word"}
                    onChange={(
                      event: React.SyntheticEvent<HTMLElement>,
                      data: any
                    ) => this.setState({ fileType: "docx" })}
                    checked={this.state.fileType === "docx"}
                  />
                </Form.Group>
              </Segment>
            </Form.Field>
            <Form.Field
              label={"ขนาดซองจดหมาย"}
              width={16}
              control={EnvelopSize}
              inputFieldEnvelopSize="envelopSize"
              valueFieldEnvelopSize={this.state.envelopSize}
              onChangeInputField={this.onChangeInputEnvelopSize}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="grey"
            floated="left"
            basic
            onClick={() => this.close()}
          >
            {t("modal.EnvelopsModal.buttonNo")}
          </Button>
          <Button color="teal" onClick={() => this.onConfirm()}>
            {t("modal.EnvelopsModal.buttonYes")}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }

  private onChangeInputEnvelopSize = (fieldname: string, value: any) => {
    this.setState({ envelopSize: value });
  };

  private onConfirm = async () => {
    const { onConfirm } = this.props;
    try {
      this.setState({ loading: true });
      await onConfirm(
        this.state.letterType,
        this.state.fileType,
        this.state.envelopSize
      );
      this.close();
    } catch (e) {
      console.log(e);
      throw e;
    } finally {
      this.setState({ loading: false });
    }
  };
}

export default withTranslation()(EnvelopsMultiModal);
